import Component from '../inherited/Component'
import { ScrollObserver, valueAtPercentage } from 'aatjs'

export default class AnimationsVerticalScrollSlider extends Component {
  constructor (elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
    this._slides = this._elem.querySelectorAll('[data-slide]')
    this._addedListener = false
    this._isMounted = false
  }

  mount () {
    this._elem.style.setProperty('--cards-count', this._slides.length)
    this._elem.style.setProperty('--card-height',`${this._slides[0].clientHeight}px`)
    this._elem.style.setProperty('padding-bottom',`${this._slides.length * 20}px`)

    Array.from(this._slides).forEach((slide, index) => {
      const offsetTop = 20 + index * 20
      slide.style.paddingTop = `${offsetTop}px`
      
      if (index === this._slides.length - 1) {
        return
      }
      
      const toScale = 1 - (this._slides.length - 1 - index) * 0.1
      const nextSlide = this._slides[index + 1]
      const slideInner = slide.querySelector('.slide-inner')
      
      ScrollObserver.Element(nextSlide, {
        offsetTop,
        offsetBottom: window.innerHeight - slide.clientHeight
      }).onScroll(({ percentageY }) => {
        slideInner.style.scale = valueAtPercentage({
          from: 1,
          to: toScale,
          percentage: percentageY
        })
        slideInner.style.filter = `brightness(${valueAtPercentage({
          from: 1,
          to: 0.6,
          percentage: percentageY
        })})`
      })
    })

  }
}